import React, { Component } from 'react';
import { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { AbstractChart } from 'containers/charts/AbstractChart';
import helpers from 'helpers';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';

class LineChart extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        if (isEqual(nextProps.data, this.props.data)) {
            return false;
        }
        return true;
    }

    render() {
        const series = [];
        const { chartRef } = this;
        const { orderedColors } = this.props.theme;
        Object.keys(this.props.data).forEach((key, index) => {
            let completeData;
            if (!this.props.categories) {
                completeData = helpers.backfill(
                    this.props.data[key].map(r => ({ x: r.date_in_ms, y: r[this.props.y] })),
                    this.props.backfillBuckets
                );
            } else {
                completeData = this.props.data[key].map(r => r[this.props.y]);
            }

            series.push({
                ...(this.props.yOptions || {}),
                name: this.props.yTitle || helpers.convertToDisplayValue(key),
                color: orderedColors[index % orderedColors.length],
                data: completeData
            });
        });

        const xAxis = helpers.xAxisConfig({
            type: this.props.xAxisType,
            xAxisLabel: this.props.xAxisLabel,
            options: { categories: this.props.categories }
        });

        const yAxis = helpers.yAxisConfig({
            yAxisLabel: this.props.yTitle || this.props.y,
            options: { ...(this.props.yAxisOptions || {}) }
        });

        const plotOptions = {
            series: {
                animation: {
                    duration: this.props.animateDuration
                }
            },
            area: { stacking: 'normal' }
        };

        return (
            <ContentTile padding={helpers.contentPadding('chart-with-legend')}>
                <ContentHeader hideCSVExport={this.props.hideCSVExport} chartRef={chartRef} type={'chart'}>{this.props.title}</ContentHeader>
                <AbstractChart
                    ref={chartRef}
                    exportName={this.props.exportName}
                    config={{
                        meta: {
                            title: this.props.title
                        },
                        chart: {
                            type: 'line',
                            zoomType: 'xy'
                        },
                        exporting: helpers.commonExportingConfig(this.props.exportName),
                        credits: {
                            enabled: false
                        },
                        plotOptions,
                        title: {
                            text: null
                        },
                        tooltip: {
                            split: true,
                            crosshairs: {
                                width: 1,
                                color: 'gray',
                                dashStyle: 'shortdot'
                            }
                        },
                        legend: {
                            itemStyle: {
                                color: this.props.theme.charts.axisAssets
                            }
                        },
                        xAxis,
                        yAxis,
                        series: this.props.series || series
                    }} />
            </ContentTile>
        );
    }
}

LineChart.propTypes = {
    data: PropTypes.object,
    xAxisLabel: PropTypes.string,
    backfillBuckets: PropTypes.array,
    y: PropTypes.string,
    yTitle: PropTypes.string,
    yOptions: PropTypes.object,
    yAxisOptions: PropTypes.object,
    categories: PropTypes.array,
    animateDuration: PropTypes.number,
    title: PropTypes.string.isRequired
};

export default withTheme(LineChart);



// WEBPACK FOOTER //
// ./src/components/molecules/charts/LineChart.js